import http from '@/http/aisea/axios'
const resource = "/enterprise/users/";

export default {
  fetch(userId) {
    return http.get(`${resource}${userId}/licenses`);
  },

  add(userId, id, payload) {
    return http.post(`${resource}${userId}/licenses${id}`, payload);
  },

  update(userId, id, payload) {
    return http.put(`${resource}${userId}/licenses${id}`, payload);
  },

  delete(userId, id) {
    return http.delete(`${resource}${userId}/licenses${id}`);
  },

  linkTo(userId, userLicenseId, payload) {
    return http.post(`${resource}${userId}/licenses/${userLicenseId}/pictures`, payload);
  },

  unlinkTo(userId, userLicenseId, pictureLicenseId) {
    return http.delete(`${resource}${userId}/licenses/${userLicenseId}/pictures/${pictureLicenseId}`);
  },

};
